import {Injectable} from '@angular/core';
import {DipRegistrationAlertState} from './dip-registartion-alert-state.model';
import {DipRegistrationStore} from '../stores/dip-registration-store';

@Injectable()
export class DipRegistrationAlertStore extends DipRegistrationStore<DipRegistrationAlertState> {

  constructor() {
    super(new DipRegistrationAlertState());
  }

  updateAlertState(state: DipRegistrationAlertState) {
    this.setState(new DipRegistrationAlertState(
      state.isEnabled,
      state.type,
      state.messageKey,
      state.titleKey
    ));
  }

  resetAlertState() {
    this.setState({
      isEnabled: false,
      type: '',
      messageKey: '',
      titleKey: ''
    });
  }
}
